webpackJsonp([114276838955818,60335399758886],{

/***/ 121:
/***/ (function(module, exports) {

	module.exports = {"data":{"allJavascriptFrontmatter":{"edges":[{"node":{"fields":{"slug":"/contact/"},"frontmatter":{"title":"Contact"}}},{"node":{"fields":{"slug":"/posts/"},"frontmatter":{"title":"Posts"}}},{"node":{"fields":{"slug":"/"},"frontmatter":{"title":"Home"}}}]}},"layoutContext":{}}

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(264);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(121);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  right: 1rem;\n  bottom: 1rem;\n  position: fixed;\n"], ["\n  right: 1rem;\n  bottom: 1rem;\n  position: fixed;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: ", ";\n  overflow: hidden;\n  transition: width .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    height .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    border-radius .25s;\n  background-color: #add8e6;\n  position: relative;\n  border-radius: ", ";\n  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14),\n    0 1px 10px 0 rgba(0,0,0,0.12),\n    0 2px 4px -1px rgba(0,0,0,0.3);\n\n  &:hover {\n    filter: brightness(1.05);\n  }\n\n  & {\n    cursor: pointer;\n  }\n\n  &[data-sleeping='true'] {\n    height: ", ";\n    border-radius: ", " ", " ", " ", ";\n    transition: height 1s, border-radius 1s;\n    transform-origin: bottom;\n    animation: breathing 3s ease-out 1s infinite alternate;\n  }\n\n  @keyframes breathing {\n    from {\n      transform: scale3d(1, 1, 1);\n      border-radius: ", " ", " ", " ", ";\n    }\n    to {\n      transform: scale3d(1.02, 0.9, 1);\n      border-radius: ", " ", " ", " ", ";\n    }\n  }\n"], ["\n  height: ", ";\n  width: ", ";\n  overflow: hidden;\n  transition: width .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    height .5s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    border-radius .25s;\n  background-color: #add8e6;\n  position: relative;\n  border-radius: ", ";\n  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14),\n    0 1px 10px 0 rgba(0,0,0,0.12),\n    0 2px 4px -1px rgba(0,0,0,0.3);\n\n  &:hover {\n    filter: brightness(1.05);\n  }\n\n  & {\n    cursor: pointer;\n  }\n\n  &[data-sleeping='true'] {\n    height: ", ";\n    border-radius: ", " ", " ", " ", ";\n    transition: height 1s, border-radius 1s;\n    transform-origin: bottom;\n    animation: breathing 3s ease-out 1s infinite alternate;\n  }\n\n  @keyframes breathing {\n    from {\n      transform: scale3d(1, 1, 1);\n      border-radius: ", " ", " ", " ", ";\n    }\n    to {\n      transform: scale3d(1.02, 0.9, 1);\n      border-radius: ", " ", " ", " ", ";\n    }\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  margin: 0 auto;\n  right: 0;\n  position: relative;\n  transition: transform .5s cubic-bezier(.02,.91,.71,1);\n"], ["\n  width: ", ";\n  margin: 0 auto;\n  right: 0;\n  position: relative;\n  transition: transform .5s cubic-bezier(.02,.91,.71,1);\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  from {\n    top: ", ";\n  }\n  to {\n    top: ", ";\n  }\n"], ["\n  from {\n    top: ", ";\n  }\n  to {\n    top: ", ";\n  }\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  top: ", ";\n  background-color: #2ac;\n  border-radius: 50%;\n  position: absolute;\n\n  &[data-sleeping='false'][data-blinking='true'] {\n    animation: blink-left 10s infinite;\n  }\n\n  @keyframes blink-left {\n    0% {\n      height: ", ";\n      width: ", ";\n      left: 0;\n      top: ", ";\n    }\n    0.5% {\n      height: ", ";\n      width: ", ";\n      left: ", ";\n      top: ", ";\n    }\n    2.5% {\n      height: ", ";\n      width: ", ";\n      left: 0;\n      top: ", ";\n    }\n  }\n\n  &[data-sleeping='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    animation: ", " 1s forwards;\n    background-color: #add8e6;\n  }\n\n  &[data-open='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    background-color: #add8e6;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  top: ", ";\n  background-color: #2ac;\n  border-radius: 50%;\n  position: absolute;\n\n  &[data-sleeping='false'][data-blinking='true'] {\n    animation: blink-left 10s infinite;\n  }\n\n  @keyframes blink-left {\n    0% {\n      height: ", ";\n      width: ", ";\n      left: 0;\n      top: ", ";\n    }\n    0.5% {\n      height: ", ";\n      width: ", ";\n      left: ", ";\n      top: ", ";\n    }\n    2.5% {\n      height: ", ";\n      width: ", ";\n      left: 0;\n      top: ", ";\n    }\n  }\n\n  &[data-sleeping='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    animation: ", " 1s forwards;\n    background-color: #add8e6;\n  }\n\n  &[data-open='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    background-color: #add8e6;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  top: ", ";\n  right: 0;\n  background-color: #2ac;\n  border-radius: 50%;\n  position: absolute;\n\n  &[data-sleeping='false'][data-blinking='true'] {\n    animation: blink-right 10s infinite;\n  }\n\n  @keyframes blink-right {\n    0% {\n      height: ", ";\n      width: ", ";\n      right: 0;\n      top: ", ";\n    }\n    0.5% {\n      height: ", ";\n      width: ", ";\n      right: ", ";\n      top: ", ";\n    }\n    2.5% {\n      height: ", ";\n      width: ", ";\n      right: 0;\n      top: ", ";\n    }\n  }\n\n  &[data-sleeping='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    animation: ", " 1s forwards;\n    background-color: #add8e6;\n  }\n\n  &[data-open='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    background-color: #add8e6;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  top: ", ";\n  right: 0;\n  background-color: #2ac;\n  border-radius: 50%;\n  position: absolute;\n\n  &[data-sleeping='false'][data-blinking='true'] {\n    animation: blink-right 10s infinite;\n  }\n\n  @keyframes blink-right {\n    0% {\n      height: ", ";\n      width: ", ";\n      right: 0;\n      top: ", ";\n    }\n    0.5% {\n      height: ", ";\n      width: ", ";\n      right: ", ";\n      top: ", ";\n    }\n    2.5% {\n      height: ", ";\n      width: ", ";\n      right: 0;\n      top: ", ";\n    }\n  }\n\n  &[data-sleeping='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    animation: ", " 1s forwards;\n    background-color: #add8e6;\n  }\n\n  &[data-open='true']:after {\n    position: relative;\n    content: \" \";\n    display: block;\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    top: ", ";\n    background-color: #add8e6;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  bottom: ", ";\n  right: 1rem;\n  text-align: center;\n  position: fixed;\n  transition: visibility 0s .2s, opacity .2s;\n  visibility: hidden;\n  opacity: 0;\n  font-size: 3rem;\n\n  &[data-open='true'] {\n    transition: opacity .5s;\n    transition-delay: .5s;\n    visibility: visible;\n    opacity: 1;\n  }\n\n  a:link {\n    color: steelblue;\n    text-decoration: none;\n  }\n\n  a:visited {\n    color: steelblue;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n"], ["\n  bottom: ", ";\n  right: 1rem;\n  text-align: center;\n  position: fixed;\n  transition: visibility 0s .2s, opacity .2s;\n  visibility: hidden;\n  opacity: 0;\n  font-size: 3rem;\n\n  &[data-open='true'] {\n    transition: opacity .5s;\n    transition-delay: .5s;\n    visibility: visible;\n    opacity: 1;\n  }\n\n  a:link {\n    color: steelblue;\n    text-decoration: none;\n  }\n\n  a:visited {\n    color: steelblue;\n  }\n\n  a:hover {\n    text-decoration: underline;\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(48);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__(32);
	
	var _gatsbyLink = __webpack_require__(81);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ChillyWrapper = _styledComponents2.default.div(_templateObject);
	
	var Head = _styledComponents2.default.div(_templateObject2, (0, _typography.rhythm)(3), (0, _typography.rhythm)(3), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(2.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(1.5), (0, _typography.rhythm)(.3), (0, _typography.rhythm)(.3));
	
	var Eyes = _styledComponents2.default.div(_templateObject3, (0, _typography.rhythm)(1.5));
	
	var fallAsleep = (0, _styledComponents.keyframes)(_templateObject4, (0, _typography.rhythm)(-.75), (0, _typography.rhythm)(-.1));
	
	var LeftEye = _styledComponents2.default.div(_templateObject5, (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(1), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.25), (0, _typography.rhythm)(.8), (0, _typography.rhythm)(-.15), (0, _typography.rhythm)(1.75), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.75), fallAsleep, (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.7));
	
	var RightEye = _styledComponents2.default.div(_templateObject6, (0, _typography.rhythm)(.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(1), (0, _typography.rhythm)(1), (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.25), (0, _typography.rhythm)(.8), (0, _typography.rhythm)(-.15), (0, _typography.rhythm)(1.75), (0, _typography.rhythm)(1), (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(1), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.75), fallAsleep, (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.5), (0, _typography.rhythm)(.7));
	
	var Links = _styledComponents2.default.div(_templateObject7, (0, _typography.rhythm)(4));
	
	var Chilly = function (_React$Component) {
	  _inherits(Chilly, _React$Component);
	
	  function Chilly() {
	    _classCallCheck(this, Chilly);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      leftEyeBlinking: true,
	      rightEyeBlinking: true,
	      sleeping: false
	    };
	    _this.timer = _this.timer.bind(_this);
	    _this.refreshTimer = _this.refreshTimer.bind(_this);
	    _this.sleepCount = 30;
	    return _this;
	  }
	
	  Chilly.prototype.componentDidMount = function componentDidMount() {
	    this.timerInterval = setInterval(this.timer, 1000);
	  };
	
	  Chilly.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearInterval(this.timerInterval);
	  };
	
	  Chilly.prototype.timer = function timer() {
	    if (this.sleepCount && !this.props.open) this.sleepCount--;else if (!this.state.sleeping && !this.props.open) this.setState({
	      sleeping: true
	    });
	  };
	
	  Chilly.prototype.refreshTimer = function refreshTimer() {
	    this.sleepCount = 30;
	    this.setState({
	      sleeping: false
	    });
	  };
	
	  Chilly.prototype.render = function render() {
	    var _this2 = this;
	
	    console.log(this.state);
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        Links,
	        {
	          "data-open": this.props.open
	        },
	        this.props.links.map(function (obj, i) {
	          return _react2.default.createElement(
	            "div",
	            { key: i },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { onClick: _this2.props.onClick, to: obj.fields.slug },
	              obj.frontmatter.title
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        ChillyWrapper,
	        { onClick: this.props.onClick },
	        _react2.default.createElement(
	          Head,
	          {
	            "data-sleeping": this.state.sleeping,
	            "data-open": this.props.open,
	            onMouseOver: this.refreshTimer,
	            linksLength: this.props.links.length
	          },
	          _react2.default.createElement(
	            Eyes,
	            null,
	            _react2.default.createElement(LeftEye, {
	              "data-sleeping": this.state.sleeping,
	              "data-open": this.props.open,
	              "data-blinking": this.state.leftEyeBlinking
	            }),
	            _react2.default.createElement(RightEye, {
	              "data-sleeping": this.state.sleeping,
	              "data-open": this.props.open,
	              "data-blinking": this.state.rightEyeBlinking
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Chilly;
	}(_react2.default.Component);
	
	exports.default = Chilly;
	module.exports = exports["default"];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  overflow: hidden;\n'], ['\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  transition: transform 1s;\n  transform-origin: top right;\n  &[data-open=\'true\'] {\n    transform: rotate(30deg);\n  }\n'], ['\n  background-color: white;\n  transition: transform 1s;\n  transform-origin: top right;\n  &[data-open=\'true\'] {\n    transform: rotate(30deg);\n  }\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(81);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Chilly = __webpack_require__(263);
	
	var _Chilly2 = _interopRequireDefault(_Chilly);
	
	var _styledComponents = __webpack_require__(48);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Background = _styledComponents2.default.div(_templateObject);
	
	var MovingPage = _styledComponents2.default.div(_templateObject2);
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      chillyActive: false
	    };
	    _this.closeChilly = _this.closeChilly.bind(_this);
	    _this.openChilly = _this.openChilly.bind(_this);
	    _this.toggleChilly = _this.toggleChilly.bind(_this);
	    _this.links = _this.formatLinks(props.data);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    this.injectHtmlColor();
	  };
	
	  Template.prototype.injectHtmlColor = function injectHtmlColor() {
	    document.querySelector("html").style.backgroundColor = "#dcecf3";
	  };
	
	  Template.prototype.closeChilly = function closeChilly() {
	    console.log("Closing Chilly");
	    this.setState({
	      chillyActive: false
	    });
	  };
	
	  Template.prototype.openChilly = function openChilly() {
	    console.log("Opening Chilly");
	    this.setState({
	      chillyActive: true
	    });
	  };
	
	  Template.prototype.toggleChilly = function toggleChilly() {
	    this.setState(function (currState) {
	      return {
	        chillyActive: !currState.chillyActive
	      };
	    });
	  };
	
	  Template.prototype.formatLinks = function formatLinks(data) {
	    console.log(data);
	    return data.allJavascriptFrontmatter.edges.map(function (i) {
	      return i.node;
	    });
	  };
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    return _react2.default.createElement(
	      Background,
	      null,
	      _react2.default.createElement(
	        MovingPage,
	        { 'data-open': this.state.chillyActive, onClick: this.closeChilly },
	        children()
	      ),
	      _react2.default.createElement(_Chilly2.default, {
	        onClick: this.toggleChilly,
	        open: this.state.chillyActive,
	        links: this.links
	      })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	Template.propTypes = {
	  children: _react2.default.PropTypes.func,
	  location: _react2.default.PropTypes.object,
	  route: _react2.default.PropTypes.object
	};
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-29dd1af170b7b4bb7b24.js